export default {
	DOCUMENT_BATCHES: 'companies/:company_id/document-batches',
	DOCUMENT_BATCH: 'companies/:company_id/document-batches/items',
	DOCUMENT_BATCH_ERRORS: 'companies/:company_id/document-batches/errors'
}